import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient, HttpResponse, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';


import { RestService } from '../providers/rest.service';
import { ComparePropertiesModel } from '../../shared/models/ComparePropertiesModel';
import { ComparePropertyDetailModel } from '../../shared/models/ComparePropertyDetailModel';
import { PortfolioAnalysisInputModel } from '../models/PortfolioAnalysisInputModel';
import { PortfolioAnalysisDetailComponent } from '../../MyPortfolio/PortfolioAnalysis/PortfolioAnalysisDetail/Portfolio-Analysis-Detail.component';

@Injectable()
export class ComparisonService extends RestService {

    public comparePropertiesModelData = {} as ComparePropertiesModel;
    public isComparePage: boolean = false;

    // get property details for comparison 
    getPropertyDetailForComparison(comparePropertiesModel: ComparePropertiesModel): Observable<ComparePropertyDetailModel[]> {
        return this.postForEntityObject('user1031/getPropertyDetailForComparison/', comparePropertiesModel);
    }

    saveAnalyze(comparePropertiesModel: ComparePropertiesModel){
        return this.postForEntityObject('user1031/saveAnalyze/', comparePropertiesModel);
  }

  savePortfolioAnalysis(portfolioAnalysisInputModel: PortfolioAnalysisInputModel) {
    return this.postForEntityObject('dataentryproperty/savePortfolioAnalysis/', portfolioAnalysisInputModel);
  }

    // Get the property details by Guid
    //getAnalyzeDetail(id: number): Observable<ComparePropertiesModel> {
    //    return this.postForEntityObject('user1031/getAnalyzeDetail/' + id, '');
    //}

    getAnalyzeDetail(analyzeId: number): Observable<ComparePropertiesModel> {
        return this.get<ComparePropertiesModel>('user1031/getAnalyzeDetail/' + analyzeId);
  }

    getPortfolioAnalyzeDetail(analyzeId: number): Observable<ComparePropertiesModel> {
      return this.get<ComparePropertiesModel>('dataentryproperty/getPortfolioAnalyzeDetail/' + analyzeId);
    }

    getPropertyDetailWithRentTermForComparison(comparePropertiesModel: ComparePropertiesModel): Observable<ComparePropertyDetailModel[]> {
        return this.postForEntityObject('user1031/getPropertyDetailWithRentTermForComparison/', comparePropertiesModel);
  }

  getPortfolioDetailWithRentTermForComparison(comparePropertiesModel: PortfolioAnalysisInputModel): Observable<ComparePropertyDetailModel[]> {
    return this.postForEntityObject('dataentryproperty/getPortfolioDetailWithRentTermForComparison/', comparePropertiesModel);
  }
}
